// src/routes/pricingRoutes.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Lazy load components for better performance
const PricingCalculatorImproved = React.lazy(() => import('../pages/pricing/PricingCalculatorImproved'));
const QuoteList = React.lazy(() => import('../pages/pricing/QuoteList'));
const QuoteDetail = React.lazy(() => import('../pages/pricing/QuoteDetail'));
const QuoteEdit = React.lazy(() => import('../pages/pricing/QuoteEdit'));
const PricingConfigClean = React.lazy(() => import('../pages/settings/PricingConfigClean'));

const pricingRoutes = [
  // Pricing Calculator
  {
    path: 'pricing',
    children: [
      {
        index: true,
        element: <Navigate to="/pricing/calculator" replace />
      },
      {
        path: 'calculator',
        element: (
          <ProtectedRoute requiredPermission={{ resource: 'quotes', action: 'create' }}>
            <PricingCalculatorImproved />
          </ProtectedRoute>
        )
      },
      {
        path: 'quotes',
        element: (
          <ProtectedRoute requiredPermission={{ resource: 'quotes', action: 'read' }}>
            <QuoteList />
          </ProtectedRoute>
        )
      },
      {
        path: 'quotes/new',
        element: (
          <ProtectedRoute requiredPermission={{ resource: 'quotes', action: 'create' }}>
            <QuoteEdit />
          </ProtectedRoute>
        )
      },
      {
        path: 'quotes/:id',
        element: (
          <ProtectedRoute requiredPermission={{ resource: 'quotes', action: 'read' }}>
            <QuoteDetail />
          </ProtectedRoute>
        )
      },
      {
        path: 'quotes/:id/edit',
        element: (
          <ProtectedRoute requiredPermission={{ resource: 'quotes', action: 'update' }}>
            <QuoteEdit />
          </ProtectedRoute>
        )
      }
    ]
  },
  // Pricing Configuration (under settings)
  {
    path: 'settings/pricing',
    element: (
      <ProtectedRoute requiredPermission={{ resource: 'pricing_config', action: 'read' }}>
        <PricingConfigClean />
      </ProtectedRoute>
    )
  }
];

export default pricingRoutes;